<template>
  <div id="box" onselectstart="return false;" >
    <div class="bgColor"></div>
    <div class="txt" ><span class="aa">请将滑块拖动到右侧</span></div>
    <!--给i标签添加上相应字体图标的类名即可-->
    <div class="slider" @mousedown="mousedownHandler($event)"><i :class="[this.isSuccess== true? 'el-icon-circle-check' : 'el-icon-d-arrow-right' ]"></i></div>
  </div>
</template>
<script>
  export default {
    data(){
      return{
        bgColor:'',
        txt:'',
        slider:'',
        icon:'',
        successMoveDistance:'',
        downX:'',
        isSuccess:'',
        flag:false,
        move:false,
      }
    },
    mounted(){
      //二、获取到需要用到的DOM元素
      var box = document.getElementById("box")//容器
        this.bgColor =this. getEle(".bgColor"),//背景色
        this.txt =this. getEle(".txt"),//文本
        this.slider = this.getEle(".slider"),//滑块
        this.icon = this.getEle(".slider>i"),
        this.successMoveDistance = box.offsetWidth- this.slider.offsetWidth,//解锁需要滑动的距离
        this.downX,//用于存放鼠标按下时的位置
        this.isSuccess = false;//是否解锁成功的标志，默认不成功
      //三、给滑块添加鼠标按下事件
    },
    methods:{
      getEle(selector){
        return document.querySelector(selector)
      },
      //3.1鼠标按下事件的方法实现
      mousedownHandler(e){
        this.bgColor.style.transition = "";
        this.slider.style.transition = "";
        var e = e || window.event || e.which;
        this.downX = e.clientX;
        //在鼠标按下时，分别给鼠标添加移动和松开事件
        document.onmousemove = this.mousemoveHandler;
        document.onmouseup = this.mouseupHandler;
      },
      getOffsetX(offset,min,max){
        if(offset < min){
          offset = min;
        }else if(offset > max){
          offset = max;
        }
        return offset;
      },
      //3.1.1鼠标移动事件的方法实现
      mousemoveHandler(e){
        if(!this.flag){
          var e = e || window.event || e.which;
          var moveX = e.clientX;
          var offsetX = this.getOffsetX(moveX - this.downX,0,this.successMoveDistance);
          this.bgColor.style.width = offsetX + "px";
          this.slider.style.left = offsetX + "px";
          if(offsetX == this.successMoveDistance){
            this.success();
          }
        }
        //如果不设置滑块滑动时会出现问题（目前还不知道为什么）
        e.preventDefault();
      },
      //3.1.2鼠标松开事件的方法实现
      mouseupHandler(e){
        if(!this.isSuccess){
          this.bgColor.style.width = 0 + "px";
          this.slider.style.left = 0 + "px";
          this.bgColor.style.transition = "width 0.8s linear";
          this.slider.style.transition = "left 0.8s linear";
        }
        document.onmousemove = null;
        document.onmouseup = null;
      },
      //五、定义一个滑块解锁成功的方法
      success(){
        this.isSuccess = true;
        this.txt.innerHTML = "<div style='color: #fff'>验证通过</div>";
        this.bgColor.style.backgroundColor ="#3094F2";
        this.slider.className = "slider active";
        this.icon.className = "el-icon-circle-check-outline";
        //滑动成功时，移除鼠标按下事件和鼠标移动事件
        this.slider.onmousedown = null;
        document.onmousemove = null;
        this.flag=true
      }
    }
  }
/*
  function getEle(selector){
    return document.querySelector(selector);
  }
*/
//四、定义一个获取鼠标当前需要移动多少距离的方法
</script>
<style scoped>
  *{
    padding: 0;
    margin: 0;
  }
  #box{
    position: relative;
    width: 85%;
    height: 40px;
    margin: 0 auto;
    margin-top: 0px;
    margin-bottom: 20px;
    background-color: #e8e8e8;
    box-shadow: 1px 1px 5px rgba(0,0,0,0.2);
  }
  .bgColor{
    position: absolute;
    left:0;
    top:0;
    width:40px;
    height: 40px;
    background-color: #3094F2;
  }
  .txt{
    position: absolute;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #000;
    text-align: center;
  }
  .slider{
    position: absolute;
    left:0;
    top:0;
    width: 50px;
    height: 38px;
    border: 1px solid #ccc;
    background: #fff;
    text-align: center;
    cursor: move;
  }
  .slider>i{
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
  }
  .slider.active>i{
    color:green;
  }
  .box .txt .aa{
    width: 100%;
    display: inline-block;
    background: -webkit-gradient(linear,left top,right top,color-stop(0,#4d4d4d),color-stop(.4,#4d4d4d),color-stop(.5,#fff),color-stop(.6,#4d4d4d),color-stop(1,#4d4d4d));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-animation: slidetounlock 3s infinite;
    -webkit-text-size-adjust: none;
  }

  @keyframes slidetounlock {
    0%{
      background-position: -200px;
    }
    100%{
      background-position: 200px ;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/DragVerify.vue